import { render, staticRenderFns } from "./WppContactsTable.vue?vue&type=template&id=62ae24f7&scoped=true"
import script from "./WppContactsTable.vue?vue&type=script&lang=js"
export * from "./WppContactsTable.vue?vue&type=script&lang=js"
import style0 from "./WppContactsTable.vue?vue&type=style&index=0&id=62ae24f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae24f7",
  null
  
)

export default component.exports